<template>
  <div id="modal_filter_medkon" class="form-modal">
    <div class="filter-pers m-b-10">
      <div class="row">
        <div class="col-md-12">
          <h6 class="fs-13" style="border-bottom: 1px solid #ccc">
            Berdasarkan Sumber
          </h6>
          <div class="form-check complete">
            <input
              type="radio"
              name="medkon_sources"
              v-model="filter_soures"
              id="semua_sources"
              value="semua_sources"
              :checked="filter_soures == 'semua_sources'"
            />
            <label for="semua_sources">Tampilkan Semua</label>
          </div>
          <div class="form-check complete">
            <input
              type="radio"
              name="medkon_sources"
              v-model="filter_soures"
              id="news"
              value="news"
              :checked="filter_soures == 'news'"
            />
            <label for="news">Online News</label>
          </div>
          <div class="form-check complete">
            <input
              type="radio"
              name="medkon_sources"
              v-model="filter_soures"
              id="media_tv"
              value="media_tv"
              :checked="filter_soures == 'media_tv'"
            />
            <label for="media_tv">Media TV</label>
          </div>
          <div class="form-check complete">
            <input
              type="radio"
              name="medkon_sources"
              v-model="filter_soures"
              id="media_cetak"
              value="media_cetak"
              :checked="filter_soures == 'media_cetak'"
            />
            <label for="media_cetak">Media Cetak</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button @click="filter_data" class="btn btn-complete pull-right">
            Cari
          </button>
          <button class="btn btn-danger pull-right m-r-5" data-dismiss="modal">
            Batal
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "modal_filter_medkon",
  data() {
    return {
      filter_soures: this.$route.query.sources
        ? atob(this.$route.query.sources)
        : "semua_sources",
    };
  },
  methods: {
    filter_data: function () {
      let queries = JSON.parse(JSON.stringify(this.$route.query));

      queries["sources"] = btoa(this.filter_soures);
      if (this.filter_soures != "semua_sources") {
        this.$router.replace({ query: queries });
      } else {
        if ("sources" in this.$route.query) {
          queries = JSON.parse(JSON.stringify(this.$route.query));
          delete queries.sources;
          this.$router.replace({ query: queries });
        }
      }
      $("#modalSlideUp").modal("hide");
    },
  },
};
</script>